// src/ui/theme/pageScopes.js
// Registro de ambitos editables del editor de estilos (F4). "General" edita la
// capa base; cada pagina edita overrides especificos (layers.teacher.pages).
//
// FUENTE UNICA del nombre de cada pagina: la clave i18n del menu lateral
// (navConfig). Asi el selector "Editando:" del editor muestra EXACTAMENTE el
// mismo nombre que el menu (Escenas, Asistentes IA, ...) y si se renombra una
// pagina, cambia en los dos sitios a la vez.
import { TEACHER_SCOPES } from "../components/AppSidebar/navConfig";

export const SCOPE_BASE = "base";
// Ambito de MARCA: edita el color primario global (capa base) con aviso. No es
// una pagina; escribe en base para que cascade a TODA la plataforma.
export const SCOPE_BRAND = "brand";

// { key: "teacher/salas", labelKey: "nav.scenes" }
export const TEACHER_PAGES = TEACHER_SCOPES.map(({ key, labelKey }) => ({
  key,
  labelKey,
}));

export const SCOPE_OPTIONS = [
  { key: SCOPE_BRAND, label: "Marca (global)", labelKey: null },
  { key: SCOPE_BASE, label: "General", labelKey: null },
  ...TEACHER_PAGES,
];

// Clave i18n del nombre de un ambito (null para General). El nombre legible se
// resuelve en el editor con i18n + override (ver Page_Styles.nameFor).
export function scopeLabelKey(key) {
  return SCOPE_OPTIONS.find((s) => s.key === key)?.labelKey || null;
}

// Fallback estatico (sin i18n): General o la propia key.
export function scopeLabel(key) {
  return SCOPE_OPTIONS.find((s) => s.key === key)?.label || key;
}
